import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContent from '../FolderContent';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder: PapiGallection;
}

const DesktopGallectionSimpleView: React.FC<Props> = ({ currentFolder }) => {
  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <FoldersHeader />
        <FolderSlider />
        <div id="sub-folder-gallery">
          <FolderContent
            key={currentFolder.folderId}
            folderId={currentFolder.folderId}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionSimpleView.displayName = 'DesktopGallectionSimpleView';

export default DesktopGallectionSimpleView;
